import { useEffect } from 'react';
import '../styles/global.css';

export default function Modal({ modal, setModal }) {
  // 1. Funciones de control centralizadas para reusarlas en los botones y el teclado
  const handleConfirm = () => {
    modal.onConfirm?.();
    setModal({ ...modal, visible: false });
  };

  const handleCancel = () => {
    modal.onCancel?.();
    setModal({ ...modal, visible: false });
  };

  const handleClose = () => {
    setModal({ ...modal, visible: false });
  };

  // 2. Escuchar el teclado mediante useEffect
  useEffect(() => {
    // Si el modal no está visible, no agregamos el listener
    if (!modal.visible) return;

    const handleKeyDown = (event) => {
      const key = event.key.toLowerCase();

      // Atajos para confirmación (Solo si el tipo es 'confirm')
      if (modal.tipo === 'confirm') {
        if (key === 's') {
          handleConfirm();
        } else if (key === 'n') {
          handleCancel();
        }
      }

      // Atajos para cerrar (Funciona en cualquier tipo de modal)
      if (key === 'c' || key === 'escape') {
        handleClose();
      }
    };

    // Registrar el evento en la ventana
    window.addEventListener('keydown', handleKeyDown);

    // Limpieza (cleanup) al desmontar o cuando el modal cambie de estado
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modal.visible, modal.tipo]); // Se ejecuta cada vez que cambia la visibilidad o el tipo

  // Si no es visible, no renderiza nada
  if (!modal.visible) return null;

  const colores = {
    success: '#28a745',
    error: '#dc3545',
    warning: '#ffc107',
    confirm: '#007bff',
    info: '#6c757d'
  };

  return (
    <div className="overlay">
      <div className="modal">
        <h3 style={{ marginTop: 0, color: colores[modal.tipo] }}>
          {modal.titulo}
        </h3>

        <p>{modal.mensaje}</p>

        <div style={{ textAlign: 'right', marginTop: '15px' }}>
          {modal.tipo === 'confirm' && (
            <>
              {/* Añadí (S) y (N) visualmente para que el usuario conozca el atajo */}
              <button onClick={handleConfirm}>
                Sí <kbd>S</kbd>
              </button>

              <button onClick={handleCancel}>
                No <kbd>N</kbd>
              </button>
            </>
          )}

          <button onClick={handleClose}>
            Cerrar <kbd>C</kbd>
          </button>
        </div>
      </div>
    </div>
  );
}